import { CustomerReducer } from "stores/customer/interfaces"

export const getUserFromLocalStorage = () => {
  return JSON.parse(JSON.parse(window.localStorage.getItem('persist:@PHC') || '{}')?.customerReducer || '{}') as CustomerReducer
}